import { Dimensions, StyleSheet } from "react-native";
import Colors from "../Color/Colors";
import { globalFontStyle } from "../Font/FontFamily";
import Width from "../Width";
import { isMobile } from "../../utils/commonMethods";
import { globalImport } from "../../common/globalImports";
import { globalConfigurableData } from "../../utils/globalConstant";

export const globalStyle = StyleSheet.create({
  outerElementBox: {
    backgroundColor: Colors.bgWhite,
    borderRadius: 100,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    borderWidth: 0.5,
    borderColor: "rgba(0, 0, 0, 0.20)",
  },
  headerContainer: {
    // backgroundColor: Colors.bgWhite,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingVertical: 13,
    alignItems: "center",
    borderBottomColor: Colors.borderColor,
    //borderWidth: 0.2,
    shadowColor: "rgba(0, 0, 0, 0.15)",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    top: 0,
    position: globalImport?.isWeb ? "sticky" : "relative",
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
    elevation: 3,
    zIndex: 1000,
  },
  pageContainer: {
    backgroundColor: globalConfigurableData.globalThemeColor,
    flex: 1,
  },
  customBtnParentModalStyle: {
    // borderTopColor: "rgba(0, 0, 0, 0.5)",
    //borderTopWidth: 0.191541,
    paddingVertical: 15,
    //flex: 1,
    marginTop: 15,
  },
  headerBlue: {
    ...globalFontStyle.appBlueHead,
    color: Colors.tradexBlue,
  },
  toolTipStyle: {
    borderRadius: 8,
    backgroundColor: globalConfigurableData.cardBgColor,
    padding: 15,
    borderWidth: 0.75,
    borderColor: globalConfigurableData.borderColor,
  },
  modalView: {
    backgroundColor: globalConfigurableData.cardBgColor,
    paddingHorizontal: 0,
    paddingTop: 16,
    paddingBottom: 0,

    position: "absolute",
    width: Width.width,

    bottom: 0,
    alignItems: "center",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 6,
  },
  buySellScroll: {
    backgroundColor: globalConfigurableData.cardBgColor,
    maxHeight: Width.height * 0.55,
  },
  circleMainBtnForm: {
    textAlign: "center",
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 50,
    backgroundColor: Colors.black,
    color: Colors.bgWhite,
  },

  bottomAbsBtnBar: {
    position: "absolute",
    paddingHorizontal: 16,
    paddingVertical: 13,
    bottom: 0,
    flexDirection: "row",
    //borderTopColor: "rgba(0, 0, 0, 0.5)",
    //borderTopWidth: 0.191541,
    backgroundColor: globalConfigurableData.cardBgColor,
    justifyContent: "space-between",
    flex: 1,
  },
  eventHeadingStyle: {
    paddingVertical: 10,
    borderColor: Colors.black2,
    borderBottomWidth: 0.5,
    marginBottom: 20,
  },
  eventHeadingStyleBox: {
    paddingVertical: 15,
    borderColor: Colors.black2,
    borderTopWidth: 0.25,
    borderBottomWidth: 0.2,
  },
  cardContainer: {
    borderColor: globalConfigurableData.borderColor,
    backgroundColor: globalConfigurableData.cardBgColor,
    paddingHorizontal: 15,
    paddingVertical: 15,
    borderRadius: 8,
    borderWidth: 0.75,
    marginTop: isMobile() ? 15 : 20,
  },
  modalStyle: {
    height: Dimensions.get("window").height - 200,
    width: Dimensions.get("window").width - 30,
    borderRadius: 12,
  },
  errorText: {
    ...globalFontStyle.appFontSmallText,
    color: globalConfigurableData.errorTextColor1,
    marginTop: 3,
  },
  infoIcon: {
    padding: 4,
  },
  desktopRightBox: {
    backgroundColor: 'rgb(255, 255, 255)',
    borderRadius: 8,
    ...(globalImport?.isWeb ? {
      boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.1), 0px 8px 16px 0px rgba(0, 0, 0, 0.1)',
      transition: 'border-color 0.15s cubic-bezier(0.36, 0, 0.66, -0.56)',
      WebkitFontSmoothing: 'antialiased',
      overflowY: 'auto',
      position: 'sticky',
    } : {
      shadowColor: 'rgba(0, 0, 0, 0.1)',
      shadowOffset: {
        width: 0,
        height: 8,
      },
      shadowOpacity: 1,
      shadowRadius: 8,
      elevation: 8,
    }),
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginLeft: 32,
    marginRight: 24,
    marginTop: 4,
    width: 328,
    top: 0,
    zIndex: 2,
    paddingVertical: 10,
  },

  scroll_webFix: {
    flex: 1,
  },
  modalStyleCenter: {
    position: "absolute",
    alignItems: "center",
    borderRadius: 8,
    elevation: 6,
  },
  buy_sell_style: {
    textAlign: "center",
    paddingLeft: 50,
    height: 45,
    paddingVertical: 0,
  },
});
